import { Component, OnInit,NgZone, ViewChild, ElementRef, Inject, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras, RoutesRecognized, NavigationEnd } from '@angular/router';
import { AlertController, LoadingController } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service'
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { ToastService } from 'src/app/services/toast.service';
import { Platform } from '@ionic/angular';
import { ActionSheetController } from '@ionic/angular';
import { StoreService } from 'src/app/services/store.service'
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-website-header1',
  templateUrl: './website-header1.component.html',
  styleUrls: ['./website-header1.component.scss'],
})
export class WebsiteHeader1Component implements OnInit {
  data = ['Amsterdam', 'Buenos Aires', 'Cairo', 'Geneva', 'Hong Kong', 'Istanbul', 'London', 'Madrid', 'New York', 'Panama City'];
  city = localStorage.getItem('city');
  @ViewChild('popover') popover;
  pin: any;
  isOpen = false;
  locationFlag: any;
  page_number: any;
  recommendedProducts: any;
  productListA: any;
  bannerImg: any;
  middleImgbottom: any;
  merChat: any;
  productList: any;
  n: any;
  selectRef: any;
  location:any;
  locationJs: any;
  userAddress: string = ''
  userLatitude: string = ''
  userLongitude: string = ''
  addressDisplay: any;
  googlemap: any;
  isItemAvailable: boolean;
  initializeItems: any;
  display_name: any;
  searchTerm: String = '';
  str1: any;
  result: any;
  item: any;
  someSubscription: any;
  ipaddress: any;
  refreshNeeded: boolean = false;
  constructor(
    private router: Router,
    private routerActivate: ActivatedRoute,
    public alertController : AlertController,
    public userService: UserService,
    private toast: ToastService,
    private service: StoreService,
    private appVersion: AppVersion,
    private platform: Platform,
    public actionSheetController: ActionSheetController,
    private _platform: Platform,
    private changeDetectorRef: ChangeDetectorRef,
    private ngZone: NgZone,@Inject(DOCUMENT) private document: Document,
    public loadingController: LoadingController,private cdr: ChangeDetectorRef
 
  ) { 
    this.userService.cartUpdated.subscribe(res => {
      let cart = localStorage.getItem('cart');
      if(cart){
        this.n = JSON.parse(cart).length;
      }
    })
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.someSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Here is the dashing line comes in the picture.
        // You need to tell the router that, you didn't visit or load the page previously, so mark the navigated flag to false as below.
        this.router.navigated = false;
      }
    });
    
  }

  ngOnInit() {
    this.userService.appSettings.subscribe((resp:any) => {
      console.log("appSettings resp version ", resp.version);
      if(resp && resp.checkVersion && resp.version){
        console.log("resp.version ", resp.version);
        this.appVersion.getVersionNumber().then(version => {
          console.log("this.appVersion.getVersionNumber() ", version);
          if(resp.version != version){
            // this.updateAlertConfirm();
          }
        });
      }
    })

    if (!localStorage.getItem('city')) {
      // this.AddController();

    }
    this.fetchProductLimit();
    this.topBannerImage();
    this.city = localStorage.getItem('city')
    this.middleBannerImage(this.city);

    this.pin = localStorage.getItem('pin')
     // Edit By vikash Kumar
  // Location Api display in navbar
    const value=localStorage.getItem('city');
           if (value){
            this.city=value
            // document.getElementById('modal').style.display='none';
          
           } 
  else{
    this.getP()
  }
 
          }

  fetchCatStoreTerm() {
    let navigationParams: NavigationExtras = { state: { city: this.city, pin: this.pin, backPageFlag: { backPageFlagInfo: "H", city: this.city, pin: this.pin } } };
    this.router.navigate(['/search-product'], navigationParams)
  }
  wishlist() {
    this.router.navigate(['/wishlist'])
    
  }
  Myprofile(){
    this.router.navigate(['/profile'])
   
  }

  cartPage() {
   
    this.router.navigate(['/cart'])
  
  }

  loginmobile() {
    this.router.navigate(['/account-page'])
   
  }
  nearby(){
    this.router.navigate(['/nearby'])
    
  }
  wallet(){
    this.router.navigate(['/spot-wallet'])
    
  }

  async AddController() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Choose Location',
      cssClass: 'action-search-custom-class',
      buttons: [
        // {
        //   text: 'Zip Code',
        //   icon: 'pin-outline',
        //   handler: () => {
        //     this.locationFlag = 2;
        //     this.page_number = 1;
        //     this.enterSerachkeyword(this.locationFlag)
        //     console.log('Share clicked');
        //   }
        // }, 
        {
          text: 'City',
          icon: 'business-outline',
          handler: () => {
            this.locationFlag = 3;
            this.page_number = 1;
            // this.enterSerachkeyword(this.locationFlag)
            this.enterCityRadio(this.locationFlag)
            console.log('Play clicked');
          }
        }
      ]
    });
    await actionSheet.present();

    const { role } = await actionSheet.onDidDismiss();
  }
  fetchProductLimit() {
    const proObj = {}
    this.service.webProductCat(proObj).subscribe((result: any) => {

      this.productListA = result.msg
      console.log(this.productListA)
    }, (error: any) => {
      this.toast.presentToast(error)
    });
  }
  topBannerImage() {
    this.service.topBannerImg().subscribe((result: any) => {
      console.log("Response banner image", result)
      this.bannerImg = result
      this.merchantCatList()
    }, (error: any) => {
      this.toast.presentToast(error)

    });
  }

  middleBannerImage(city:any) {
    let that = this;
    const DisObj = {
      city: city
    }
    this.service.middleBannerImg1(DisObj).subscribe((result: any) => {

      this.ngZone.run(() => {
        console.log("result ", result)
        that.middleImgbottom = result;
        console.log("that.middleImgbottom ", that.middleImgbottom)
      });
  
    }, (error: any) => {

    });
   
  }
  async enterCityRadio(flag: number) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Select City',
      inputs: [
        {
          name: 'radio1',
          type: 'radio',
          label: 'Edison',
          value: 'Edison',
  
        },
        {
          name: 'radio1',
          type: 'radio',
          label: 'Kanpur',
          value: 'Kanpur',
        },
        {
          name: 'radio1',
          type: 'radio',
          label: 'Lucknow',
          value: 'Lucknow',
        },
        {
          name: 'radio1',
          type: 'radio',
          label: 'Delhi NCR',
          value: 'Delhi NCR',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            // Handle cancel button click if needed
          },
        },
        {
          text: 'OK',
          handler: async (data) => {
            if (flag === 3) {
              const loading = await this.loadingController.create({
                message: 'Reloading...',
                translucent: true,
              });

              // Show the loading spinner before reloading
              await loading.present();

              this.productList = [];
              this.page_number = 1;
              localStorage.setItem('city', data);
              this.city = data;
              localStorage.setItem('pin', '');
              this.pin = null;
              console.log('Confirm flag == 3', this.city);
              this.recommendedProducts = [];
              this.middleBannerImage(this.city);

              // Reload the page

              // Dismiss the loading spinner after reloading
              await loading.dismiss();
            }
          },
        },
      ],
    });

    await alert.present();
  }
  merchantCatList() {
    this.service.preDifnedCat().subscribe((result: any) => {
      console.log("Response from merchandied catagories", result)
      this.merChat = result

    }, (error: any) => {
      this.toast.presentToast(error)
    });
  }
  isModalOpen = false;

  setOpen(isOpen: boolean) {
    this.isModalOpen = isOpen; 
  }
  app(){
    window.open("https://play.google.com/store/apps/details?id=com.spot.mckinsol&hl=en_IN&gl=US")
  }
  fetchCatStoreTerm1() {
    let navigationParams: NavigationExtras = { state: { city: this.city, pin: this.pin, backPageFlag: { backPageFlagInfo: "H", city: this.city, pin: this.pin } } };
    this.router.navigate(['/search-product'], navigationParams);
  }


  // Edit By vikash Kumar
  // Location get Api
  handleAddressChange(address: any) {
    this.userAddress = address.formatted_address;
     this.addressDisplay = this.userAddress.split(',')[0];   
    this.userLatitude = address.geometry.location.lat()
    this.userLongitude = address.geometry.location.lng();
    localStorage.setItem('city', this.addressDisplay);
    this.middleBannerImage(this.addressDisplay);
    document.getElementById('modal-one').style.display='hidden'; 
  }

onClickSegment(event) {
  console.log("event hi",event)
}
getLocation(ev: any) {
  console.log('i m ')
  const val = ev.target.value;
  if (val && val.trim() !== '') {
      this.isItemAvailable = true;
    
      this.service.addressLookup({value:val}).subscribe((data)=>{
        this.googlemap=data;
        // console.log("ee",data)
        console.log("response google map", this.googlemap)})
     
      } else {
        this.isItemAvailable = false;
      }
      
    }
  
    change(val) {
      const searchbox = document.getElementById('popover');
      console.log(searchbox, 'hjh..');
      searchbox.style.display = 'none';
      this.city = val.split(',')[0];
      localStorage.setItem('city', this.city);
      this.middleBannerImage(this.city);
      this.presentLoading();
    //   setTimeout(() => {
    //     this.reloadMiddleBannerImage();
    //   }, 0);
    // }
    
    // reloadMiddleBannerImage() {
    //   this.middleBannerImage(this.city);
    //   this.presentLoading();
    }
    

getP(){
  console.log("i am hit")
this.service.getIpAddress().subscribe(res => {

  this.ipaddress = res['ip'];
  console.log("ip")
  this.service.getGEOLocation(this.ipaddress).subscribe(res => {
console.log(res);
   this.city = res['city'];
   localStorage.setItem('city', this.city)
   // document.getElementById('trigger-button').style.display='none';
   this.middleBannerImage(this.city)
  });
  //console.log(res);

});}
async presentLoading() {
  const loading = await this.loadingController.create({
    cssClass: 'my-custom-class',
    message: 'Please wait...',
    duration: 5000,
  });
  await loading.present();

  const { role, data } = await loading.onDidDismiss();
  console.log('Loading dismissed!');
}
}
